/**
 * SV Cloud's own mark is a brand direction deliverable, so in the prototype it
 * lives behind a single token slot, --brand-mark, swappable in one place when
 * it lands. That keeps the mark off the critical path.
 */

interface MarkProps {
  size?: number;
}

export function Mark({ size = 22 }: MarkProps) {
  return (
    <span
      aria-hidden="true"
      style={{
        width: size,
        height: size,
        flex: 'none',
        display: 'grid',
        placeItems: 'center',
        borderRadius: 'var(--r-sm)',
        border: '1px solid var(--border-loud)',
        background: 'var(--brand-mark, var(--bg-raised))',
        backgroundSize: 'cover',
        color: 'var(--text-2)',
        fontFamily: 'var(--font-mono)',
        fontSize: Math.round(size * 0.42),
        letterSpacing: 'var(--ls-wide)',
      }}
    >
      SV
    </span>
  );
}
